import { Modal } from '@/components/modal';
import { Button } from '@/components/ui/button';
import { LoadingSpinner } from './loading-spinner';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onLeave: () => void;
  onSaveAndLeave: () => void;
  title?: string;
  isSaving?: boolean;
}

/**
 * Modal component to warn users about leaving with unsaved changes
 */
export function UnsavedChangesModal({
  isOpen,
  onCancel,
  onLeave,
  onSaveAndLeave,
  title = 'Unsaved Changes',
  isSaving = false,
}: UnsavedChangesModalProps) {
  return (
    <Modal
      isDialogOpen={isOpen}
      setIsDialogOpen={(open) => {
        if (!open) {
          onCancel();
        }
      }}
      title={title}
      footer={
        <div className='flex justify-end gap-3'>
          <Button variant='outline' onClick={onLeave} disabled={isSaving}>
            Leave without saving
          </Button>
          <Button onClick={onSaveAndLeave} disabled={isSaving}>
            {isSaving ? (
              <>
                <LoadingSpinner /> Saving...
              </>
            ) : (
              'Save Changes'
            )}
          </Button>
        </div>
      }
    >
      <div className='py-4'>
        <p className='text-sm text-muted-foreground'>
          You have unsaved changes. If you leave this page now, your changes
          will be lost.
        </p>
      </div>
    </Modal>
  );
}
